export default [
    {
        page: 'home',
        documents: {
            easilyAccessedPDFs: [
                {
                    name: "B206L AAIP",
                    link: "http://rotor-apps.com/MHI/manuals/206LAAIPP.pdf"
                },
                {
                    name: "B407 AAIP",
                    link: "http://rotor-apps.com/MHI/manuals/407AAIPP.pdf"
                },
                {
                    name: "BO-105 AAIP",
                    link: "http://rotor-apps.com/MHI/manuals/105AAIP.pdf"
                },
                {
                    name: "AW119 AAIP",
                    link: "http://www.rotor-apps.com/MHI/manuals/119AAIP.pdf"
                },
                {
                    name: "B412 CAMP",
                    link: "http://www.rotor-apps.com/MHI/manuals/Camp.pdf"
                },
                {
                    name: "Emergency Pocket Checklist",
                    link: "https://www.rotor-apps.com/MHI/manuals/epc.pdf"
                },
            ],
            segregatedPDFs: [
                {
                    title: "Power Trend Charts",
                    documents: [
                        {
                            name: "206/407",
                            link: "http://www.rotor-apps.com/MHI/forms/RR_Eng_Chart.xls"
                        },
                        {
                            name: "412", 
                            link: "http://www.rotor-apps.com/MHI/forms/Engtc.pdf"  
                        },
                    ]
                }
            ]
        },
        links: [
            {
                name: "Bell Site",
                link: "https://mybell.com/bell/en/USD/login"
            },
            {
                name: "ICA's",
                link: "https://drive.google.com/drive/u/2/folders/0B9Uzp-tOQL7CVkE3QjdBaGl3YlU"
            },
        ]
    },
    {
        page: 'calm',
        documents: {
            segregatedPDFs: [
                {
                    title: "BELL 206L1",
                    documents: [
                        {
                            name: "N315MH",
                            abbreviatedlink: "http://rotor-apps.com/MHI/calm/Forecast/315MH.pdf",
                            fullLink: "http://rotor-apps.com/MHI/calm/315MH.pdf",
                        },
                    ]
                },
                {
                    title: "BELL 206L3",
                    documents: [
                        {
                            name: "N304MH",
                            abbreviatedlink: "http://rotor-apps.com/MHI/calm/Forecast/304MH.pdf",
                            fullLink: "http://rotor-apps.com/MHI/calm/304MH.pdf",
                        },
                        {
                            name: "N306MH",
                            abbreviatedlink: "http://rotor-apps.com/MHI/calm/Forecast/306MH.pdf",
                            fullLink: "http://rotor-apps.com/MHI/calm/306MH.pdf",
                        },
                       
                    ]
                },
                {
                    title: "BELL 206L4",
                    documents: [
                        {
                            name: "N193AL",
                            abbreviatedlink: "http://rotor-apps.com/MHI/calm/Forecast/193AL.pdf",
                            fullLink: "http://rotor-apps.com/MHI/calm/193AL.pdf",
                        },
                        {
                            name: "N305MH",
                            abbreviatedlink: "http://rotor-apps.com/MHI/calm/Forecast/305MH.pdf",
                            fullLink: "http://rotor-apps.com/MHI/calm/305MH.pdf",
                        },
                       {
                            name: "N311MH",
                            abbreviatedlink: "http://rotor-apps.com/MHI/calm/Forecast/311MH.pdf",
                            fullLink: "http://rotor-apps.com/MHI/calm/311MH.pdf",
                        },
						{
                            name: "N314MH",
                            abbreviatedlink: "http://rotor-apps.com/MHI/calm/Forecast/314MH.pdf",
                            fullLink: "http://rotor-apps.com/MHI/calm/314MH.pdff",
                        },
                        {
                            name: "N316MH",
                            abbreviatedlink: "http://rotor-apps.com/MHI/calm/Forecast/316MH.pdf",
                            fullLink: "http://rotor-apps.com/MHI/calm/316MH.pdf",
                        },
                    ]
                },
                {
                    title: "BELL 407",
                    documents: [
                        {
                            name: "N308MH",
                            abbreviatedlink: "http://rotor-apps.com/MHI/calm/Forecast/308MH.pdf",
                            fullLink: "http://rotor-apps.com/MHI/calm/308MH.pdf",
                        },
                        {
                            name: "N309MH",
                            abbreviatedlink: "http://rotor-apps.com/MHI/calm/Forecast/309MH.pdf",
                            fullLink: "http://rotor-apps.com/MHI/calm/309MH.pdf",
                        },
                        {
                            name: "N312MH",
                            abbreviatedlink: "http://rotor-apps.com/MHI/calm/Forecast/312MH.pdf",
                            fullLink: "http://rotor-apps.com/MHI/calm/312MH.pdf",
                        },
                        {
                            name: "N407PA",
                            abbreviatedlink: "http://rotor-apps.com/MHI/calm/Forecast/407PA.pdf",
                            fullLink: "http://rotor-apps.com/MHI/calm/407PA.pdf",
                        },
                        {
                            name: "N407RH",
                            abbreviatedlink: "http://rotor-apps.com/MHI/calm/Forecast/407RH.pdf",
                            fullLink: "http://rotor-apps.com/MHI/calm/407RH.pdf",
                        },
                        {
                            name: "N319MH",
                            abbreviatedlink: "http://rotor-apps.com/MHI/calm/Forecast/319MH.pdf",
                            fullLink: "http://rotor-apps.com/MHI/calm/319MH.pdf",
                        },
                    ]
                },
                {
                    title: "AW119",
                    documents: [
                        {
                            name: "N320MH",
                            abbreviatedlink: "http://rotor-apps.com/MHI/calm/Forecast/320MH.pdf",
                            fullLink: "http://rotor-apps.com/MHI/calm/320MH.pdf",
                        },
                    ]
                },
                {
                    title: "BO-105",
                    documents: [
                        {
                            name: "N326MH",
                            abbreviatedlink: "http://rotor-apps.com/MHI/calm/Forecast/326MH.pdf",
                            fullLink: "http://rotor-apps.com/MHI/calm/326MH.pdf",
                        },
                        {
                            name: "N327MH",
                            abbreviatedlink: "http://rotor-apps.com/MHI/calm/Forecast/327MH.pdf",
                            fullLink: "http://rotor-apps.com/MHI/calm/327MH.pdf",
                        },
                    ]
                },
                {
                    title: "BELL 412",
                    documents: [
                        {
                            name: "N328MH",
                            abbreviatedlink: "http://rotor-apps.com/MHI/calm/Forecast/328MH.pdf",
                            fullLink: "http://rotor-apps.com/MHI/calm/328MH.pdf",
                        },
                        {
                            name: "N330MH",
                            abbreviatedlink: "http://rotor-apps.com/MHI/calm/Forecast/330MH.pdf",
                            fullLink: "http://rotor-apps.com/MHI/calm/330MH.pdf",
                        },
                    ]
                },
            ]
        },
        links: [
            {
                name: "Flt Time",
                link: "https://docs.google.com/forms/d/e/1FAIpQLScOsh82emmzt9yvXWFxbbC1fPurC7uwXdVHODtD91HfiKsmcw/viewform?embedded=true"
            },
            {
                name: "Dashboard",
                link: "https://docs.google.com/spreadsheets/d/e/2PACX-1vSr751z0JzvPF91DtykMiN8N7uwHjZ-MOM25I7HJfneLo1tOr-AJdjNXFPu9JOXfOa9D_ZylSmAIlNv/pubhtml?gid=233567636&single=true"
            },
        ]
    },
    {
        page: "manuals",
        documents: {
            easilyAccessedPDFs: [
                {
                    name: "Flight Permit",
                    link: "http://rotor-apps.com/MHI/manuals/SFP.pdf"
                },
                {
                    name: "Tool Control",
                    link: "http://rotor-apps.com/MHI/manuals/tcp.pdf"
                },
                {
                    name: "Master Pubs",
                    link: "http://rotor-apps.com/MHI/manuals/mpl.pdf"
                },
                {
                    name: "Gmm",
                    link: "http://www.rotor-apps.com/MHI/manuals/gmm.pdf"
                },
            ],
            segregatedPDFs: [
                {
                    title: "Maintenance",
                    documents: [
                        {
                            name: "206/407 mel",
                            link: "https://drive.google.com/file/d/11cnw8UtVRXoi4Om1tWtsedc9SM0c7whn/view",
                        },
                        {
                            name: "bo-105 mel",
                            link: "https://drive.google.com/file/d/1jPt5D5UtEbl7Mtx3QZu2sNvGRB0bhJNu/view",
                        },
                        {
                            name: "aw119 mel",
                            link: "https://drive.google.com/file/d/12iW2WZqBztNYTl8sfqqCVA3Da4jldk9d/view",
                        },
                        {
                            name: "412 mel",
                            link: "https://drive.google.com/file/d/1tawPxHJttiJpvwl2Fui9gaZQnhiRbV3c/view",
                        },
                        {
                            name: "nef",
                            link: "https://drive.google.com/file/d/1UjyPy_bNxjkGNSZtELT1esdygrPySjuX/view",
                        },
                        {
                            name: "fuel",
                            link: "https://drive.google.com/file/d/1b3Lo4u698gLBnS5JRwpLYeszMvlvMY23/view",
                        },
                    ]
                },
                {
                    title: "Operations",
                    documents: [
                        {
                            name: "sop",
                            link: "https://drive.google.com/file/d/1qySu9nylBdc2nXjHjqGXfOC4m5NBQsHZ/view",
                        },
                        {
                            name: "ifr sop",
                            link: "https://drive.google.com/file/d/1aVBVc96SdXVsxP3YwCWvQ3VO3j-genGo/view",
                        },
                        {
                            name: "nvg sop",
                            link: "https://drive.google.com/file/d/17P9TgHeZFW997zpbtMUU7MgYvloSa9qj/view",
                        },
                        {
                            name: "gom",
                            link: "https://drive.google.com/file/d/1ZIeKFc27cWlqXL9WeD5lz3YKjO2IEM8i/view",
                        },
                        {
                            name: "rlcfm",
                            link: "https://drive.google.com/file/d/1VryEwAALxfC6IeQJatto9RLU4GcoBmJN/view",
                        },
                        {
                            name: "haz ext load",
                            link: "https://drive.google.com/file/d/1iUviIVKDN_TW99ERVFMS5BBJOj5Uzh2n/view",
                        },
                    ]
                },
                {
                    title: "part 145",
                    documents: [
                        {
                            name: "homer rsm",
                            link: "https://drive.google.com/file/d/1uOSONP2U4RL3c0Lxdgsq83fyqbpYOQYI/view",
                        },
                        {
                            name: "homer qcm",
                            link: "https://drive.google.com/file/d/1pjefRpVCIwtgHUF-AocNyaGq1iOaGjTV/view",
                        },
                        {
                            name: "fairbanks rsm",
                            link: "https://drive.google.com/file/d/17FFUM9WLHgNhNAFtvMAMdv6-uedg5Wre/view",
                        },
                        {
                            name: "fairbanks qcm",
                            link: "https://drive.google.com/file/d/1oyTAIT2-KHGk23Dc8c7mydTr5fb5S53m/view",
                        },
                        {
                            name: "rs forms",
                            link: "https://drive.google.com/file/d/1LKKCSBaFXnZ3Fzm5EnkAVf9MdOQgmTiV/view",
                        },
                    ]
                },
                {
                    title: "op specs",
                    documents: [
                        {
                            name: "part 133",
                            link: "https://drive.google.com/file/d/128n2a3RQ09s-ibmqs1fj_tLuCrwUvcLg/view",
                        },
                        {
                            name: "part 135",
                            link: "https://drive.google.com/file/d/1u2GmunhgRo6swXsGUPD6L_itj1fLhA5p/view",
                        },
                        {
                            name: "part 137",
                            link: "https://drive.google.com/file/d/1RwgmMGaT0RYvzdEo0IyvhfgkOBsPWaEV/view",
                        },
                        {
                            name: "part 145h",
                            link: "https://drive.google.com/file/d/1FdI4YS4nOV0PfFOwR7k6jbJ6yf8Vdmjv/view",
                        },
                        {
                            name: "part 145f",
                            link: "https://drive.google.com/file/d/1Tn20vaTyV3O_bC1r4W1_ZXNkq9k9yKW_/view",
                        },
                    ]
                },
                {
                    title: "certifications",
                    documents: [
                        {
                            name: "part 133",
                            link: "https://drive.google.com/file/d/1AQAncvTMy2DHf7My4Tmcs253KUzyl-Fp/view",
                        },
                        {
                            name: "part 135",
                            link: "https://drive.google.com/file/d/1ySUt1nhadWOhuYf6P3K4UA6vcwoIngDO/view",
                        },
                        {
                            name: "part 137",
                            link: "https://drive.google.com/file/d/1OTSvR2d58DHV3bQKTl9Avr8zHGgMMlQy/view",
                        },
                        {
                            name: "part 145h",
                            link: "https://drive.google.com/file/d/1TyzUsnXs21emiA4eIIw_pJsGkRNUpEEg/view",
                        },
                        {
                            name: "part 145f",
                            link: "https://drive.google.com/file/d/1LX2XwYG0p1UMMfz9YMWaw34FjkSJxKGk/view",
                        },
                    ]
                },
                {
                    title: "rosters",
                    documents: [
                        {
                            name: "inspector stamp",
                            link: "http://rotor-apps.com/MHI/manuals/Rosters/sr.pdf",
                        },
                        {
                            name: "rii",
                            link: "http://rotor-apps.com/MHI/manuals/RII.pdf",
                        },
                        {
                            name: "hom cap list",
                            link: "http://rotor-apps.com/MHI/manuals/homc.pdf",
                        },
                        {
                            name: "fai cap list",
                            link: "http://rotor-apps.com/MHI/manuals/faic.pdf",
                        },
                        {
                            name: "insp rts",
                            link: "http://rotor-apps.com/MHI/manuals/Rosters/RtoS145.pdf",
                        },
                    ]
                },
            ],
            oasCards: [
                {
                    name: "N193AL",
                    link: "http://rotor-apps.com/MHI/manuals/OAS/N193AL.pdf"
                },
                {
                    name: "N304MH",
                    link: "http://rotor-apps.com/MHI/manuals/OAS/N304MH.pdff"
                },
                {
                    name: "N305MH",
                    link: "http://rotor-apps.com/MHI/manuals/OAS/N305MH.pdf"
                },
                {
                    name: "N306MH",
                    link: "http://rotor-apps.com/MHI/manuals/OAS/N306MH.pdf"
                },
                
                {
                    name: "N308MH",
                    link: "http://rotor-apps.com/MHI/manuals/OAS/N308MH.pdf"
                },
                {
                    name: "N309MH",
                    link: "http://rotor-apps.com/MHI/manuals/OAS/N309MH.pdf"
                },
                {
                    name: "N311MH",
                    link: "http://rotor-apps.com/MHI/manuals/OAS/N311MH.pdf"
                },
				{
                    name: "N312MH",
                    link: "http://rotor-apps.com/MHI/manuals/OAS/N312MH.pdf"
                },
                {
                    name: "N314MH",
                    link: "http://rotor-apps.com/MHI/manuals/OAS/N314MH.pdf"
                },
                {
                    name: "N315MH",
                    link: "http://rotor-apps.com/MHI/manuals/OAS/N315MH.pdf"
                },
                {
                    name: "N316MH",
                    link: "http://rotor-apps.com/MHI/manuals/OAS/N316MH.pdf"
                },
                {
                    name: "N319MH",
                    link: "http://rotor-apps.com/MHI/manuals/OAS/N319MH.pdf"
                },
                {
                    name: "N320MH",
                    link: "http://rotor-apps.com/MHI/manuals/OAS/N320MH.pdf"
                },
                {
                    name: "N326MH",
                    link: "http://rotor-apps.com/MHI/manuals/OAS/N326MH.pdf"
                },
                {
                    name: "N327MH",
                    link: "http://rotor-apps.com/MHI/manuals/OAS/N327MH.pdf"
                },
                {
                    name: "N328MH",
                    link: "http://rotor-apps.com/MHI/manuals/OAS/N328MH.pdf"
                },
                {
                    name: "N330MH",
                    link: "http://rotor-apps.com/MHI/manuals/OAS/N330MH.pdf"
                },
                {
                    name: "N407PA",
                    link: "http://rotor-apps.com/MHI/manuals/OAS/N407PA.pdf"
                },
                {
                    name: "N407RH",
                    link: "http://rotor-apps.com/MHI/manuals/OAS/N407RH.pdf"
                },
            ],
        },
        links: [
            {
                name: "Rolls-Royce",
                link: "https://www.aviall.com/aviallstorefront/"
            }
        ]
    },
    {
        page: "training",
        trainingCategories: [
            {
                type: "part 145",
                quizzes: [
                    {
                        name: "part 145 review",
                        reviewLink: "https://docs.google.com/presentation/d/e/2PACX-1vRl7Bb1ivVPkBf5CDYkV5X6eQmbiKIgz5qMKTCSgjJCEDn5jqn7CuC8uUosn3uMfD3RdF3ZVZyDYG0F/embed?start=false&loop=false&delayms=3000&slide=id.g297e92da4_2_153",
                        quizLink: "https://docs.google.com/forms/d/e/1FAIpQLSf4EI11akACL0UdQrz88JOdHfxnjqungrdZm5tWguQQp7kpTw/viewform?embedded=true"
                    },
                    {
                        name: "repair station manual",
                        reviewLink: "https://docs.google.com/presentation/d/e/2PACX-1vR1_ZGwrYZ0wYYfCf22oBDFL9PVirtiPtQuOScAkSMxlSTy9T6z5rYquev-YWQ_Vwg-Pt3dcNbQEI7x/embed?start=false&loop=false&delayms=3000",
                        quizLink: "https://docs.google.com/forms/d/e/1FAIpQLSfhOjMwVEyPoQONZAi0fIrrG6w9AI-OTmbq82usYZPLIophjw/viewform?embedded=true"
                    },
                    {
                        name: "quality control manual",
                        reviewLink: "https://docs.google.com/presentation/d/e/2PACX-1vQMeo5Ts7MuyMdyKDIXI1ag9va4Oc4JMdu3_4iz2ChajAgJcIGlQy2pXA9ZZCkBbQGhOOQlWSkQGxwK/embed?start=false&loop=false&delayms=3000",
                        quizLink: "https://docs.google.com/forms/d/e/1FAIpQLSfvuGmUijGusm0edCltENshegIg0SGkZ6NKHYRzj7xrzA5K1A/viewform?embedded=true"
                    },
                    {
                        name: "incoming recieving inspector training *",
                        reviewLink: "https://docs.google.com/presentation/d/e/2PACX-1vR9-jQ8lKJ4HJ9Z14Z5-KmyQ88lf5Ngv-8s2dysaENRMhEl4Tz1WY_GK080YqIlFwv2P45hoggOzvLL/embed?start=false&loop=false&delayms=3000",
                        quizLink: "https://docs.google.com/forms/d/e/1FAIpQLSfZCc_H9yW95gUNyyessjrDAzoPA1g7Zl-TVXh1haB3tKqNJQ/viewform?embedded=true"
                    },
                    {
                        name: "suspected unapproved parts",
                        reviewLink: "https://docs.google.com/presentation/d/e/2PACX-1vQ7Rda6rbpo13ChudN-J2oF263FZaoQcBRWA7zfS1cEb7S6O8gARXBnwBlwvG0_OhJsB2Tic2v8Kmdp/embed?start=false&loop=false&delayms=3000",
                        quizLink: "https://docs.google.com/forms/d/e/1FAIpQLSfIVZcVzTxUGgTa_Gb1_KayBypCnVQfobVmm4lS50v-nPnAZQ/viewform?embedded=true"
                    },
                ],
                forms: [
                    {
                        name: "course evaluation form tr-0011",
                        link: "https://docs.google.com/forms/d/e/1FAIpQLSe1JeJhrpQ1NpdwdhaywRvMyz8z185HMSB4HbUa_jUjNNp57Q/viewform?embedded=true",
                    },
                ],
                notes: [
                    {
                        message: "* Only required for Incoming/Recieving Inspectors"
                    }
                ],
                examResults: [
                    {
                        link: "https://docs.google.com/spreadsheets/d/e/2PACX-1vT5Smh3SX141ycFRDIQTsJyx6ewgdjHwKt5uwIgjAPpEa7-eST8X-OwahVJkK4FyIDdnATz34WAGtnZ/pubhtml?widget=true&amp;headers=false",
                        name: "part 145 exam results"
                    }
                ]
            },
            {
                type: "part 135",
                quizzes: [
                    {
                        name: "inital training",
                        reviewLink: "https://docs.google.com/presentation/d/e/2PACX-1vQwnP6giEAXc6-MkuyYqH3BvF9ahKPhb9ijTIU1lrOZ5jPTSoNUycRz2ti8s4XKDYnj01BhuvgIhep3/embed?start=false&loop=false&delayms=3000",
                        quizLink: "https://docs.google.com/forms/d/e/1FAIpQLSenUn3r2rmdPkkjG5RpIHCTXSY3YZbwmDLrTUkXOq3rTd1CaA/viewform?embedded=true"
                    },
                    {
                        name: "part 135 review",
                        reviewLink: "https://docs.google.com/presentation/d/e/2PACX-1vRhWv1QEP_4JKWH4F9rBAcSVHYxLcH6EPQqJHw5Oe0T-fvILuF1AQBPa9bX-bgjho4CBtUhome_wV_Z/embed?start=false&loop=false&delayms=3000",
                        quizLink: "https://docs.google.com/forms/d/e/1FAIpQLSfN_FrbSkl1kiezEaz2AE7M0qoVGx8gZHSnt1QVSwttPhgg5A/viewform?embedded=true"
                    },
                    {
                        name: "gmm",
                        reviewLink: "https://docs.google.com/presentation/d/e/2PACX-1vSORabLyDwT9NTFcdtbwrz98HG5YJQJ4HJuodqo1GfnvBZD4B6Z_hde01a4OsQdlZ7-3N2J_z5xaf4S/embed?start=false&loop=false&delayms=3000",
                        quizLink: "https://docs.google.com/forms/d/e/1FAIpQLSfVUOcXmcr5Kmvl0tWztdpBVEchRTTlu8K158O88jl4zyTa_w/viewform?embedded=true"
                    },
                    {
                        name: "camp program - 412 *",
                        reviewLink: "http://www.rotor-apps.com/MHI/manuals/Camp.pdf",
                        quizLink: "https://docs.google.com/forms/d/e/1FAIpQLSdF-or-PJW9ucm989NumNFIBAxR7ZjElY-AyWtwDPLYfHdUVw/viewform?embedded=true"
                    },
                    {
                        name: "rii training **",
                        reviewLink: "https://docs.google.com/presentation/d/e/2PACX-1vTyMHVf7bWdrp59KIzEXMHtE5Ahm-B2oQwWIQvLCKGNw8qN20UNsZBWyYAHeRfihNxyyooLrePAy4HH/embed?start=false&loop=false&delayms=3000",
                        quizLink: "https://docs.google.com/forms/d/e/1FAIpQLSfuybDVjfsKKSsWVXE3ejlx2MsGiyYtD-0F6_PeJGq8Ixmz6w/viewform?embedded=true"
                    },
                    {
                        name: "human factors",
                        reviewLink: "https://docs.google.com/presentation/d/e/2PACX-1vTLWi-gbN0U7rQX1EVFq8STNB-5CerejNGsLeCyQKupSFP7q7UlNQM4FGalpm1r8DGQwfYUNhWEGuIs/embed?start=false&loop=false&delayms=3000",
                        quizLink: "https://docs.google.com/forms/d/e/1FAIpQLSeAb1izn7LvHRzUJBD08QCjImF6MbI6ASlZ3tL7kepnAvc2iA/viewform?embedded=true"
                    },
                    {
                        name: "hazmat intro",
                        reviewLink: "https://docs.google.com/presentation/d/e/2PACX-1vT9o_vcqfUGx9vrg-w3k_fJhd5NZtNRLkdSQ6_7AxfQJG8mbCBoVZhj1EtKBqf4_L6Zox40tMAg3LFC/embed?start=false&loop=false&delayms=3000",
                        quizLink: "https://docs.google.com/forms/d/e/1FAIpQLSfIXx_jfQwgRdEIQPffWngGEaVO5kjjIbLepATnKXHjKGa55g/viewform?embedded=true"
                    },
                    {
                        name: "hazmat air carrier",
                        reviewLink: "https://docs.google.com/presentation/d/e/2PACX-1vRUGcOBqC6qyyAEewzAOq3i_tTBlYAVDL-Gr9dXjgybiOQ_6qOKMRJcmXOhKFTtsYz1VUPO09KbTESf/embed?start=false&loop=false&delayms=3000",
                        quizLink: "https://docs.google.com/forms/d/e/1FAIpQLSde6BdcnBNkyK4iBGkH6XhhGKrCc01BhaMi2YzQyQqBbG0QlA/viewform?embedded=true"
                    },
                ],

                notes: [
                    {
                        message: "* Only required for RII Inspectors and Bell 412 Maintenance Personnel",
                    },
                    {
                        message: "** Only required for RII Inspectors",
                    },
                ],
                examResults: [
                    {
                        link: "https://docs.google.com/spreadsheets/d/e/2PACX-1vRcngm7sATqrY1016gbOnCAX6IJjunloBfVvILulaR7OMidUq7Yh3kYYJzucBnIiOG_7dhgn7vWYpB_/pubhtml?widget=true&amp;headers=false",
                        name: "part 135 exam results"
                    }
                ]
            },
            {
                type: "fuel",
                reviews: [
                    {
                        name: "fuel handling",
                        reviewLink: "https://docs.google.com/presentation/d/e/2PACX-1vR7JqaETMVHrO-sXwVldZWdGDMzaKl29pQBOsFuIYFFMcDCLd4ZiBirC7xPAto2bMwIy09ocrMqn_zy/embed?start=false&loop=false&delayms=3000"
                    },
                    {
                        name: "fuel recieving",
                        reviewLink: "https://docs.google.com/presentation/d/e/2PACX-1vQP6ZkF-zHaTetzDhgC1rHYz9yfrn9SbLJ3G3z-CED8cBOk00gDfTRAksGfM7bAET_18zlbzc0073v2/embed?start=false&loop=false&delayms=3000"
                    },
                    {
                        name: "stormwater training",
                        reviewLink: "https://docs.google.com/presentation/d/e/2PACX-1vSqFQt4KgH8hMWlZR758O0XCGIwowSRcCLtdVKEVLv7sMTKxtmYUDTNOUf_vjbyJ_nv8V-EaKi7QhxZ/embed?start=false&loop=false&delayms=3000"
                    },
                    {
                        name: "spill prevention",
                        reviewLink: "https://docs.google.com/presentation/d/e/2PACX-1vQmK7WhLGM7ue1O8WDlbsmJN1bUdnk8HOVdVA3VNCFC13NlXY-JEI1vGRpOLkGB-eut6ndo3YwgXxj3/embed?start=false&loop=false&delayms=3000"
                    },
                ],
                quizzes: [
                    {
                        name: "fuel handling & recieving",
                        quizLink: "https://docs.google.com/forms/d/e/1FAIpQLSerEuixO_VDDW3aicm0hZMiH_Nxop2IYLRts1vBKJ5guOSSWQ/viewform?embedded=true"
                    },
                    {
                        name: "stormwater and spill prevention",
                        quizLink: "https://docs.google.com/forms/d/e/1FAIpQLSdi4CXR3QJe4A8BcjdQbJpCO3Js1a1Mq0xXsU055j00_8CaGA/viewform?embedded=true" 
                    },
                ],

                notes: [
                    {
                        message: "use fuel quality manual for exam",
                        link: "http://rotor-apps.com/MHI/manuals/fqm.pdf"
                    }
                ],

                examResults: [
                    {
                        link: "https://docs.google.com/spreadsheets/u/1/d/e/2PACX-1vSxiSUiSlRAGQH229avm19abSlyUuOZ0n1nWlt7HB7zw8YF29hF_YFZ402GKxgUSYbojZ1QW_Q69lPd/pubhtml?gid=13845552&amp;single=true%22+frameborder%3D%220%22+width%3D%22760%22+height%3D%22749%22+allowfullscreen%3D%22true%22+mozallowfullscreen%3D%22true%22+webkitallowfullscreen%3D%22true%22%3E%3C/iframe%3E",
                        name: "fuel exam results"
                    }
                ]
            },
            {
                type: "human factors",
                reviews: [
                    {
                        name: "part 145 repair station training part 1",
                        reviewLink: "https://docs.google.com/presentation/d/e/2PACX-1vTLWi-gbN0U7rQX1EVFq8STNB-5CerejNGsLeCyQKupSFP7q7UlNQM4FGalpm1r8DGQwfYUNhWEGuIs/embed?start=false&loop=false&delayms=3000"
                    },
                    {
                        name: "part 145 repair station training part 2",
                        reviewLink: "https://docs.google.com/presentation/d/e/2PACX-1vQH3qxnQd6RYPhD0DA4xcrSEymRlXtFVEj5YRqfxxwLyhZ8I7WuptPVAPV-egpAuPQMK3NSNNtz9n2e/embed?start=false&loop=false&delayms=3000" 
                    },
                    {
                        name: "part 145 repair station training part 3",
                        reviewLink: "https://docs.google.com/presentation/d/e/2PACX-1vRugVXRKoNZ6MVb2z27nUqRdlpUGIR5Coz62wI4fZxdaBW6wQILqWWXMNK0mt_heDC3CKQWLF4FD93H/embed?start=false&loop=false&delayms=3000"
                    },
                ],
                quizzes: [
                    {
                        name: "human factors",
                        quizLink: "https://docs.google.com/forms/d/e/1FAIpQLSe2p9qOF-B1wodiyxxIwOU5r4dGvmIuc1KmVMRfaPzQTlRikA/viewform?embedded=true"
                    }
                ],

                examResults: [
                    {
                        link: "https://docs.google.com/spreadsheets/d/e/2PACX-1vTqDgo5HIMfu_x2Z-E8Dj-JfU4CCcSphsAjWNWp2vP3-j13Hz6c-Yolthb_RWpdMAMKiZGDLoRtafvh/pubhtml?widget=true&amp;headers=false",
                        name: "human factors exam results"
                    }
                ]
            },
        ]
    },
    {
        page: "safety",
        documents: {
            easilyAccessedPDFs: [
                {
                    name: "safety notes",
                    link: "https://drive.google.com/file/d/1555jZWI8U2aWCTVB_lb1h1jjiW1yO48q/view"
                },
                {
                    name: "risk management",
                    link: "https://drive.google.com/file/d/1W0MgtjiRyDW0foiUM00A8P6JFGYBDH3T/view"
                },
                {
                    name: "hse manual",
                    link: "https://drive.google.com/file/d/1S_TzwgPlqnfE0sWiXwbFHKRhcr92NLQ1/view"
                },
                {
                    name: "event investigation",
                    link: "https://drive.google.com/file/d/1nnwxYelvM9o2t_hlcZdSqLk6VJAAKQh3/view"
                },
                {
                    name: "emergency response plan",
                    link: "http://rotor-apps.com/MHI/manuals/erp.pdf"
                },
                {
                    name: "internal evaluation",
                    link: "https://drive.google.com/file/d/1PRuqoG7O3GF4tOPnLCvyl4RDJxafkn8f/view"
                },
                {
                    name: "sms manual",
                    link: "https://drive.google.com/file/d/1l2i3TPEmLCcCfrV_gNM9zjTO8LyI_Rsb/view"
                },
            ],
            segregatedPDFs: [
                {
                    title: "forms",
                    documents: [
                        {
                            name: "gor",
                            link: "http://rotor-apps.com/MHI/forms/GOR.pdf"
                        },
                        {
                            name: "station checklist", 
                            link: "http://rotor-apps.com/MHI/forms/schecklist.pdf"  
                        },
                        {
                            name: "first report of injury", 
                            link: "http://rotor-apps.com/MHI/forms/fri.pdf"  
                        },
                        {
                            name: "flight irregularity", 
                            link: "http://rotor-apps.com/MHI/forms/FIR.pdf"  
                        },
                    ]
                },
                {
                    title: "archive",
                    documents: [
                        {
                            name: "2015",
                            link: "https://drive.google.com/file/d/13H67G--ysRWuDwJ2LV6M7sdAZcNNZVkn/view?usp=sharing"
                        },
                        {
                            name: "2016", 
                            link: "https://drive.google.com/file/d/1zZ9DsOP56p7zU_TUXcZN2GtNQso7AHeF/view?usp=sharing"  
                        },
                        {
                            name: "2017", 
                            link: "https://drive.google.com/file/d/1hvyRAFP1gDsjkFD6rEbFWe27Bwg0K3tp/view?usp=sharing"  
                        },
                        {
                            name: "2018", 
                            link: "https://drive.google.com/file/d/1O5PiQAFgylUOP99kVEgS35Wexfly5wPA/view?usp=sharing"  
                        },
						 {
                            name: "2019", 
                            link: "https://drive.google.com/file/d/1555jZWI8U2aWCTVB_lb1h1jjiW1yO48q/view?usp=sharing"  
                        },
                    ]
                },
            ]
        },
        links: [
            {
                name: "safety data sheet",
                link: "https://sso.verisk.com/"
            },
        ]
    },
    {
        page: "memos",
        documents: {
            segregatedPDFs: [
                {
                    title: "maintenance memos",
                    documents: [
                        {
                            name: "2014",
                            link: "http://www.rotor-apps.com/MHI/manuals/CAS/2014/m14.pdf"
                        },
                        {
                            name: "2015", 
                            link: "http://www.rotor-apps.com/MHI/manuals/CAS/2015/m15.pdf"  
                        },
                        {
                            name: "2016", 
                            link: "http://www.rotor-apps.com/MHI/manuals/CAS/2016/m16.pdf"  
                        },
                        {
                            name: "2017", 
                            link: "http://www.rotor-apps.com/MHI/manuals/CAS/2017/m17.pdf"  
                        },
                        {
                            name: "2018", 
                            link: "http://www.rotor-apps.com/MHI/manuals/CAS/2018/m18.pdf"  
                        },
                        {
                            name: "2019", 
                            link: "http://www.rotor-apps.com/MHI/manuals/CAS/2019/m19.pdf"  
                        },
                        {
                            name: "cass", 
                            link: "http://rotor-apps.com/MHI/manuals/cm.pdf"  
                        },
                    ]
                },
                {
                    title: "operation memos",
                    documents: [
                        {
                            name: "2014",
                            link: "http://www.rotor-apps.com/MHI/manuals/CAS/2014/o14.pdf"
                        },
                        {
                            name: "2015", 
                            link: "http://www.rotor-apps.com/MHI/manuals/CAS/2015/o15.pdf"  
                        },
                        {
                            name: "2016", 
                            link: "http://www.rotor-apps.com/MHI/manuals/CAS/2016/o16.pdf"  
                        },
                        {
                            name: "2017", 
                            link: "http://www.rotor-apps.com/MHI/manuals/CAS/2017/o17.pdf"  
                        },
                        {
                            name: "2018", 
                            link: "http://www.rotor-apps.com/MHI/manuals/CAS/2018/o18.pdf"  
                        },
						
                    ]
                },
            ]
        },
    }
]